import { mapActions } from 'pinia';
import {
  alpha,
  closest,
  coldest,
  user,
  warmest,
} from '@@/utils/LocationSortFields';
import { useLocationsStore } from '@@/stores/Locations';
import CompareWeatherCard from '@@/components/Compare/Cards/CompareWeatherCard.vue';

export default {
  computed: {
    cardComponent() {
      return CompareWeatherCard;
    },

    sortOptions() {
      const sortOptions = [
        user,
        closest,
        alpha,
        warmest,
        coldest,
      ];

      if (!this.isFavorites) {
        sortOptions.splice(0, 3, alpha, closest);
      }

      return sortOptions;
    },
  },

  methods: {
    ...mapActions(useLocationsStore, ['fetchForecastSummary']),
  },
};
